'use client'

import Link from 'next/link'
import { trackCtaClick, trackDemoClick, trackSignupClick } from '@/lib/analytics'

interface TrackedCtaProps {
  href: string
  eventType: 'cta' | 'demo' | 'signup'
  location: string
  buttonText?: string
  children: React.ReactNode
  className?: string
}

/**
 * A Link wrapper that tracks CTA clicks in Google Analytics
 */
export function TrackedCta({
  href,
  eventType,
  location,
  buttonText,
  children,
  className,
}: TrackedCtaProps) {
  const handleClick = () => {
    switch (eventType) {
      case 'cta':
        trackCtaClick(buttonText || 'CTA', location)
        break
      case 'demo':
        trackDemoClick()
        break
      case 'signup':
        trackSignupClick(location)
        break
    }
  }

  return (
    <Link href={href} onClick={handleClick} className={className}>
      {children}
    </Link>
  )
}








